import { graphql } from '@/generated/gql';

export const DEMAND_FILES_QUERY = graphql(/* GraphQL */ `
  query DemandFiles($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        files {
          id
          isSharedWithSupplier
          quoteId
          negotiationCaseId
          negotiationCaseSequence
          createdAt
          updatedAt
        }
        permissions {
          read
          write
          assign
        }
      }
    }
  }
`);
